import { FC } from 'react';
import { Pagination } from 'antd';
import { ChevronLeftSmallIcon, ChevronRightSmallIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { NumberParam, useQueryParam, withDefault } from 'use-query-params';

interface IPaginationProps {
  current?: number;
  pageSize?: number;
  total: number | undefined;
  onChange?: (page: number) => void;
}

const CustomPagination: FC<IPaginationProps> = ({ current, total, pageSize = 30, onChange }) => {
  const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 1));
  const { pathname, query } = useRouter();

  return (
    <Pagination
      current={current || page}
      total={total}
      hideOnSinglePage
      showSizeChanger={false}
      pageSize={pageSize}
      onChange={page => {
        if (onChange) {
          onChange(page);
        } else {
          setPage(page);
        }
      }}
      itemRender={(pageNum, type, originalElement) => {
        if (type === 'prev') {
          return <ChevronLeftSmallIcon />;
        }
        if (type === 'next') {
          return <ChevronRightSmallIcon />;
        }
        const updatedQuery = { ...query, page: String(pageNum) };
        const queryString = new URLSearchParams(updatedQuery as Record<string, string>).toString();
        const href = `${pathname}?${queryString}`;

        return (
          <Link legacyBehavior href={href} scroll={false} shallow>
            {originalElement}
          </Link>
        );
      }}
    />
  );
};

export default CustomPagination;
